import { NestedData } from '@workflow/ecp-workflow/dynamic-app/service/application-api/application-api.types';

export interface CrossSell {
  applicationId: number;
  organizationID: number;
  lenderCode: string;
  applicationCrossSellSummaryId: number;
  processStartTime: string;
  processEndTime: string;
  crossSellProcessingStatusTypeID: number;
  crossSellProcessingStatusType: string;
  newCreditOffers?: NewCreditOffersEntity[] | null;
  refinanceOpportunities?: NewCreditOffersEntity[] | null;
}

export interface NewCreditOffersEntity {
  applicationCrossSellDetailId: number;
  tradeLinePK: number;
  loanTypeID: number;
  loanType: string;
  crossSellDecisionSuccess: boolean;
  decisionAmount: number;
  decisionTerm: number;
  decisionRate: number;
  decisionTier: string;
  decisionResult: string;
  estimatedPayment: number;
  message: string;
  createdOn: string;
  hasRoutingException: boolean;
  hasOtherException: boolean;
  creditor: string;
  balance?: null;
  term?: null;
  payment?: null;
  description: string;
  expirationDate?: null;
  crossSellStatusID: number;
  crossSellStatusDescription: string;
  expirationText: string;
  decisionResponseDocRepID: number;
  newApplicationID?: null;
  lenderLoanProductGUID: string;
  lenderLoanProductName: string;
  isRevolving: boolean;
  remainingTerm?: null;
  totalFinanceRemaining?: null;
  originalRate?: null;
  totalFinance?: null;
  estimatedMonthlySavings?: null;
  totalSavings?: null;
  originalAmount?: null;
  lender?: null;
  creditReportDocRepID?: null;
  hasManualDecision: boolean;
  loanOfficerGUID?: null;
  loanOfficerName?: null;
  openDate?: null;
  originalPayment?: null;
  tradeLineAccountCategoryTypeID?: null;
  tradeLineID?: null;
  originatingAmount?: null;
  originatingPayment?: null;
  originatingStageID?: null;
  originatingStatusID?: null;
  approvalAuthorityLevelNumber?: null;
  approvalAuthorityLevelName?: null;
  approvalAuthorityLevelCode?: null;
  isCoApplicantIncluded: boolean;
  stipulation: string;
  documentLinkDisplayText: string;
  termsAndConditions: string;
  docRepID: string;
  headline: string;
  subtitle: string;
}

export interface CrossSellOfferDetails {
  applicationId: number;
  offers?: OffersEntity[] | null;
}

export interface CrossSellStatusUpdate {
  applicationId: string;
  applicationCrossSellDetailIDs: number[];
}

export interface CrossSellApplyRequest {
  applicationId: number;
  crossSellId: number;
  offer?: OffersEntity;
}

export enum CrossSellRequireModule {
  Dashboard = 'Dashboard',
  OAOPostApp = 'OAOPostApp',
  OLAPostApp = 'OLAPostApp'
}

export interface CrossSellView {
  crossSellConfigId: string;
  displayName: string;
  crossSellOption: CrossSellOption; // ExpressInterest | OnClick | DeepLink (enum)
  productId: string;
  groupId: string;
  disclosures: ProductDisclosure[];
  loanType: string;
  // ArcOS details
  applicationId: number;
  applicationCrossSellSummaryId: number;
  crossSellProcessingStatusTypeId?: number | null;
  crossSellProcessingStatusType: string;
  offerDetails: NewCreditOffersEntity;
  crossSellType: CrossSellType;
}

// Placeholder types (adjust/import actual definitions if they exist elsewhere)
// TODO: Replace with concrete shape when available.
export type ProductDisclosure = {
  disclosureId: string;
  sequenceNo?: number;
  isSelected?: boolean;
  isActive?: boolean;
};
// TODO: Replace with concrete offer details structure.
export enum CrossSellOption {
  ExpressInterest = 'ExpressInterest',
  OneClick = 'OneClick',
  DeepLink = 'DeepLink'
}
export enum CrossSellType {
  None = 'None',
  CreditOffer = 'CreditOffer',
  RefinanceOffer = 'RefinanceOffer'
}

export interface CrossSellOfferResp {
  offerAction: string;
  bundle: NestedData;
  offer: Offer;
  token: any;
  fullCrossSellData?: CrossSellView;
}

export interface Offer {
  applicationId: number;
  offers: Offer2[];
}

export interface Offer2 {
  applicationCrossSellDetailID: number;
  term: number;
  rate: number;
  amount: number;
  tier: string;
  note: any;
  isSuccess: any;
  errorMessage: any;
}

export interface OffersEntity {
  isSuccess: boolean;
  errorMessage: string;
  applicationCrossSellDetailID: number;
  term: number;
  rate: number;
  amount: number;
  tier: string;
  note: string;
  description?: string;
  successCallBack?: () => void;
}
